import { object, string, array, number } from 'yup';

import { TeamViewModel } from '@/core/models/team';

export function validationSchema(teams: TeamViewModel[]) {
  return object().shape({
    name: string()
      .required('Обязательное поле')
      .test(
        'is-unique',
        'Команда с таким названием уже существует',
        (name) => !!name && teams.every((team) => team.Name !== name)
      ),
    leaders: array().of(number()),
  });
}
